import { Stack, Typography, Box } from '@mui/material';
import { BackButton } from '@xolv-mybrightlink/common';
import { useParams } from 'react-router';
import { DimensionHTMLContent } from '../components/DimensionHTMLContent';
import { useEffect, useState } from 'react';
import { getDimensionTitle } from '../services/DimensionClassService';
import { useDimensionVideoEvent } from '../hooks/useDimensionVideoEvent';

export const DimensionDetailPage = () => {
  const { postId } = useParams<{
    postId: string;
  }>();
  const [postTitle, setPostTitle] = useState<string>('');

  useEffect(() => {
    if (!postId) return;
    getDimensionTitle(postId).then((title) => {
      setPostTitle(title);
    });
  }, [postId]);

  useDimensionVideoEvent(postTitle);

  return (
    <Stack
      sx={{
        backgroundColor: 'white',
        height: '100%',
      }}
    >
      <Box sx={{ marginLeft: 10, marginTop: 12.5, p: 0 }}>
        <BackButton />
      </Box>
      <Typography
        sx={{
          fontSize: 32,
          fontWeight: 600,
          ml: 10,
          mt: 11.5,
        }}
      >
        {postTitle}
      </Typography>
      {postId && <DimensionHTMLContent postId={postId} />}
    </Stack>
  );
};
